import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useStore } from "@/store/useStore";
import { AppShell } from "@/components/AppShell";
import { ToastHost } from "@/components/Toast";
import Landing from "@/pages/Landing";
import Feed from "@/pages/Feed";
import Create from "@/pages/Create";
import StrainExplorer from "@/pages/StrainExplorer";
import Profile from "@/pages/Profile";
import Search from "@/pages/Search";
import Notifications from "@/pages/Notifications";
import Settings from "@/pages/Settings";
import About from "@/pages/About";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import VisualLanguageLab from "@/pages/VisualLanguageLab";
import NodeModifiersLab from "@/pages/NodeModifiersLab";

export default function App() {
  const theme = useStore((s) => s.theme);
  const hydrate = useStore((s) => s.hydrate);
  const location = useLocation();
  const isLabRoute = location.pathname.startsWith("/lab/");

  useEffect(() => {
    if (!isLabRoute) hydrate();
  }, [hydrate, isLabRoute]);

  // sync theme to <html class="dark"> (matches the no-flash bootstrap in index.html)
  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    try {
      localStorage.setItem("is.theme", theme);
    } catch {}
  }, [theme]);

  return (
    <>
      <Routes>
        {/* landing is standalone (no app chrome) */}
        <Route path="/" element={<Landing />} />
        <Route path="/lab/visual-language" element={<VisualLanguageLab />} />
        <Route path="/lab/node-modifiers" element={<NodeModifiersLab />} />

        {/* everything else lives inside the app shell */}
        <Route element={<AppShell />}>
          <Route path="/app" element={<Feed />} />
          <Route path="/create" element={<Create />} />
          <Route path="/s/:slug" element={<StrainExplorer />} />
          <Route path="/u/:username" element={<Profile />} />
          <Route path="/search" element={<Search />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/about" element={<About />} />
          <Route path="/admin" element={<Admin />} />
        </Route>

        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ToastHost />
    </>
  );
}
